import {welcome} from "./welcome";
import Breakpoint from './breakpoint';
//import Menu from './menu';

(() => {
  welcome();
  new Breakpoint();
  //new Menu();
})();